import { BrokerInfoDTO } from "../DTO/brokerInfoDTO";

export class BrokerInfo{

    public brokerId!:number;
    public brokerageName!:string;
    public agentFullName!: string;
    public agentId!:string;
    public agentPhoneNumber?:string;
    public agentMobilePhoneNumber?:string;
    public agentEmail!:string;

    constructor(){}

    public static mapFromDTO(param:BrokerInfoDTO):BrokerInfo{ 
        
      
        let obj = new BrokerInfo();
        try
        {
            obj.brokerId = param.brokerId;
            obj.brokerageName = param.brokerageName;
            obj.agentFullName = param.agentFullName;
            obj.agentId = param.agentId;
            obj.agentPhoneNumber = param.agentPhoneNumber;
            obj.agentMobilePhoneNumber = param.agentMobilePhoneNumber;
            obj.agentEmail = param.agentEmail;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:BrokerInfo):BrokerInfoDTO{ 
        
        let dto = new BrokerInfoDTO();
        try
        {
            dto.brokerId = param.brokerId;
            dto.brokerageName = param.brokerageName;
            dto.agentFullName = param.agentFullName;
            dto.agentId = param.agentId;
            dto.agentPhoneNumber = param.agentPhoneNumber;
            dto.agentMobilePhoneNumber = param.agentMobilePhoneNumber;
            dto.agentEmail = param.agentEmail;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

}